import { CadastreAffair as ApiCadastreAffair } from '../realty/model/CadastreAffair';
import { ApiDate } from '../realty/model/ApiDate';

export class Affair {
  public isSubmitee: boolean;
  public area: number;
  public affairDocumentDate: ApiDate;

  public constructor(apiCadastreAffair: ApiCadastreAffair, affairDocumentDate: ApiDate) {
    this.isSubmitee = apiCadastreAffair.area < 0;
    this.area = Math.abs(apiCadastreAffair.area);
    this.affairDocumentDate = affairDocumentDate;
  }
}



/** WEBPACK FOOTER **
 ** ./src/model/Affair.ts
 **/